import { render, staticRenderFns } from "./labelMat.vue?vue&type=template&id=4416ca03&scoped=true"
import script from "./labelMat.vue?vue&type=script&lang=js"
export * from "./labelMat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4416ca03",
  null
  
)

export default component.exports